import { combineReducers } from "@reduxjs/toolkit";
import LandingPageSliceReducer from "./landing_page_slice";
import LoginPageSliceReducer from "./login_page_slice";
import RootSliceReducer from "./root_slice";

/* Combined Reducer For Public Routes */
const PublicCombinedReducer = combineReducers({
  ROOT: RootSliceReducer,
  LOGIN_PAGE: LoginPageSliceReducer,
  LANDING_PAGE: LandingPageSliceReducer,
});

export default PublicCombinedReducer;
